import { render, staticRenderFns } from "./MainHead.vue?vue&type=template&id=1baa586b&scoped=true"
import script from "./MainHead.vue?vue&type=script&lang=js"
export * from "./MainHead.vue?vue&type=script&lang=js"
import style0 from "./MainHead.vue?vue&type=style&index=0&id=1baa586b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa586b",
  null
  
)

export default component.exports